import React, { PropTypes } from 'react';
import DurationFormatter from '../utils/duration';

class UsersOverviewUserTaskPill extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            quotaEditing: false,
            quotaError: false,
            quota: this.props.userTask.quota ? this.props.userTask.quota / 60 : 0
        }
    }

    handleQuotaClick = () => { this.setState({ quotaEditing: true}); };

    handleQuotaChange = (event) => {
        this.setState({ quota: event.target.value.trim() }, this.validateQuota);
    };

    handleQuotaBlur = () => {
        this.validateQuota();
        if (this.state.quotaError) return;

        this.props.handleQuotaBlur(this.props.userTask, this.state.quota);
        this.setState({ quotaEditing: false});
    };

    handleRemove = () => { this.props.handleRemove(this.props.userTask); };

    validateQuota = () => {
        let quotaError = this.props.userTask.regularTimeSpent > this.state.quota * 60;

        this.setState({ quotaError: quotaError });
    };

    render = () => {
        return (
            <div className="form-group" style={this.props.newlyAssigned ? null : {"marginTop" : "5px", "marginBottom" : "-5px"}}>
                <div className="row">
                    <div className="col-sm-4">
                        <p> <b>Task:</b> {this.props.userTask.taskClosed || !this.props.userTask.active ? <s>{this.props.userTask.taskName}</s> : this.props.userTask.taskName} </p>
                    </div>
                    <div className={this.state.quotaError ? "col-sm-3 has-error" : "col-sm-3"}>
                    {
                        this.state.quotaEditing
                            ? <input
                                ref={"quotaInput"}
                                value={this.state.quota}
                                onChange={this.handleQuotaChange}
                                onBlur={this.handleQuotaBlur}
                                type="text"
                                className="form-control"
                                placeholder="Hours"/>
                            :   <p style={{"cursor" : "pointer"}} onClick={this.handleQuotaClick} >
                                    <b>Quota: </b> {this.state.quota} h
                                </p>
                    }
                    </div>
                    <div className="col-sm-4">
                        <p>
                            <b>Quota used: </b>
                            {DurationFormatter.format(this.props.userTask.regularTimeSpent)  + " (+ " + DurationFormatter.format(this.props.userTask.overtimeTimeSpent) + ")"}
                        </p>
                    </div>
                    {(this.props.userTask.active) ?
                      <div className="col-sm-1">
                        <button onClick={this.handleRemove} style={{"background" : "transparent" , "border" : "none", "marginTop": "-15px"}}>
                          <a className="icon-btn"><span><span className="md-remove"/></span></a>
                        </button>
                      </div> :
                      <span></span>
                    }
                </div>
                <hr/>
            </div>
        );
    }
}

UsersOverviewUserTaskPill.propTypes = {
    currentQuota: PropTypes.number,
    handleQuotaBlur: PropTypes.func,
    handleRemove: PropTypes.func,
    newlyAssigned: PropTypes.bool,
    quotaError: PropTypes.bool,
    quotaEditing: PropTypes.bool,
    userTask: PropTypes.object
};

export default UsersOverviewUserTaskPill;



/** WEBPACK FOOTER **
 ** ./src/app/components/UsersOverviewUserTaskPill.js
 **/